import React from 'react';
import FinancialDiagnosisForm from '../../components/diagnosis/FinancialDiagnosisForm';
import '../../styles/admin-dashboard.css';
import '../../styles/demo-diagnosis.css';

const DemoDiagnosis = () => {
    return (
        <div className="admin-dashboard professional">
            <div className="dashboard-header">
                <div>
                    <div className="breadcrumb">DIAGNOSIS / DEMO DIAGNOSIS</div>
                    <h1>Demo Financial Diagnosis</h1>
                    <p className="dashboard-subtitle">Experience the user diagnosis flow directly from the admin dashboard.</p>
                </div>
            </div>
            
            <div className="demo-diagnosis-card">
                <div className="demo-alert">
                    <div className="alert-icon">💡</div>
                    <div className="alert-content">
                        <strong>Demo Mode:</strong> This form operates in demo mode. All steps are functional, but payment will be bypassed and the report will be saved with a 'DEMO' prefix.
                    </div>
                </div>
                
                <div className="diagnosis-form-container-admin">
                    <FinancialDiagnosisForm isAdminDemo={true} />
                </div>
            </div>
        </div>
    );
};

export default DemoDiagnosis;
